export default {
  // list
  'contract.query.contractNo': 'contractNo',
  'contract.query.contractNo.placeholder': 'Enter contractNo',
  'contract.query.contractTitle': 'contractTitle',
  'contract.query.contractTitle.placeholder': 'Enter contractTitle',
  'contract.query.businessType': 'businessType',
  'contract.query.businessType.placeholder': 'Enter businessType',
  'contract.query.contractType': 'contractType',
  'contract.query.contractType.placeholder': 'Enter contractType',
  'contract.query.partyAName': 'partyAName',
  'contract.query.partyAName.placeholder': 'Enter partyAName',
  'contract.query.partyBName': 'partyBName',
  'contract.query.partyBName.placeholder': 'Enter partyBName',
  'contract.query.status': 'status',
  'contract.query.status.placeholder': 'Enter status',
  'contract.query.signDate': 'validDate',
  'contract.query.signDate.placeholder': 'Enter validDate',
  'contract.column.contractNo': 'contractNo',
  'contract.column.contractTitle': 'contractTitle',
  'contract.column.businessType': 'businessType',
  'contract.column.contractType': 'contractType',
  'contract.column.partyAName': 'partyAName',
  'contract.column.partyBName': 'partyBName',
  'contract.column.paymentPeriod': 'paymentPeriod',
  'contract.column.signDate': 'validDate',
  'contract.column.validityPeriod': 'expirePeriod',
  'contract.column.voidStatus': 'voidStatus',
  'contract.column.createBy': 'createBy',
  'contract.column.updateBy': 'updateBy',
  'contract.column.createTime': 'createTime',
  'contract.column.updateTime': 'updateTime',
  'contract.column.dataSource': 'dataSource',
  'contract.column.remark': 'remark',
  'contract.column.status': 'status',
  'contract.operation.void': 'Void',
  'contract.operation.enable': 'Enable',
  'contract.confirm.void': 'Are you sure to void this contract?',
  'contract.confirm.enable': 'Are you sure to enable this contract?',
  'contract.void.success': 'Void Successful',
  'contract.enable.success': 'Enable Successful',
  'contract.confirm.archive': 'Are you sure to archive this contract?',
  'contract.confirm.cancelArchive': 'Are you sure to cancel archive this contract?',
  'contract.archive.success': 'Archive Successful',
  'contract.cancelArchive.success': 'Cancel Archive Successful',

  // edit
  'contract.edit.title': 'Edit Contract',
  'contract.add.title': 'Add Contract',
  'contract.edit.success': 'Edit Successful',
  'contract.add.success': 'Add Successful',
  'contract.form.contractNo.required': 'contractNo cannot be null',
  'contract.form.contractTitle.required': 'contractTitle cannot be null',
  'contract.form.businessType.required': 'businessType cannot be null',
  'contract.form.contractType.required': 'contractType cannot be null',
  'contract.form.partyAId.required': 'partyAId cannot be null',
  'contract.form.partyAName.required': 'partyAName cannot be null',
  'contract.form.partyBId.required': 'partyBId cannot be null',
  'contract.form.partyBName.required': 'partyBName cannot be null',
  'contract.form.paymentPeriod.required': 'paymentPeriod cannot be null',
  'contract.form.signDate.required': 'validDate cannot be null',
  'contract.form.contractNo': 'contractNo',
  'contract.form.contractNo.placeholder': 'Enter contractNo',
  'contract.form.contractTitle': 'contractTitle',
  'contract.form.contractTitle.placeholder': 'Enter contractTitle',
  'contract.form.businessType': 'businessType',
  'contract.form.businessType.placeholder': 'Enter businessType',
  'contract.form.contractType': 'contractType',
  'contract.form.contractType.placeholder': 'Enter contractType',
  'contract.form.partyAId': 'partyAId',
  'contract.form.partyAId.placeholder': 'Enter partyAId',
  'contract.form.partyAName': 'partyAName',
  'contract.form.partyAName.placeholder': 'Enter partyAName',
  'contract.form.partyBId': 'partyBId',
  'contract.form.partyBId.placeholder': 'Enter partyBId',
  'contract.form.partyBName': 'partyBName',
  'contract.form.partyBName.placeholder': 'Enter partyBName',
  'contract.form.paymentPeriod': 'paymentPeriod',
  'contract.form.paymentPeriod.placeholder': 'Enter paymentPeriod',
  'contract.form.signDate': 'validDate',
  'contract.form.signDate.placeholder': 'Enter validDate',
  'contract.form.validityPeriod': 'expirePeriod',
  'contract.form.validityPeriod.placeholder': 'Enter expirePeriod',
}
